export const REQUEST_WORK_MODAL_QUERY_KEY = 'request_work_modal';

export const REQUEST_WORK_MODAL_CREATE = 'create';
